import { createApi } from '@reduxjs/toolkit/query/react';
import { IPermission, IRoleReadModel, IRoleWriteModel } from '../../models/role';
import { createRbacBaseQuery, del, post, put, listToCacheTags } from '../../utils/helpers';

const roleApi = createApi({
    reducerPath: 'role',
    tagTypes: ['Role', 'RoleList', 'UserPermissions'],
    baseQuery: createRbacBaseQuery(''),
    endpoints: (builder) => ({
        getRoles: builder.query<IRoleReadModel[], void>({
            query: () => '/roles',
            providesTags: (res) => listToCacheTags(res, 'Role', 'RoleList'),
        }),
        getRoleById: builder.query<IRoleReadModel, number>({
            query: (roleId) => `/roles/${roleId}`,
            providesTags: (_, __, roleId) => [{ type: 'Role', id: roleId }],
        }),
        createRole: builder.mutation<IRoleReadModel, IRoleWriteModel>({
            query: (role) => post('/roles', role),
            invalidatesTags: ['RoleList'],
        }),
        updateRole: builder.mutation<IRoleReadModel, { roleId: number, role: IRoleWriteModel }>({
            query: ({ roleId, role }) => put(`/roles/${roleId}`, role),
            invalidatesTags: (_, __, { roleId }) => [{ type: 'Role', id: roleId }],
        }),
        deleteRole: builder.mutation<IRoleReadModel, number>({
            query: (roleId) => del(`/roles/${roleId}`),
            invalidatesTags: (_, __, roleId) => ['RoleList', { type: 'Role', id: roleId }],
        }),
        getMyRole: builder.query<IRoleReadModel, void>({
            query: () => '/me',
        }),
        getPermissions: builder.query<IPermission[], void>({
            query: () => '/permissions',
            providesTags: ['UserPermissions'],
        }),
    }),
});

export default roleApi;

export const {
    useGetRolesQuery,
    useGetRoleByIdQuery,
    useCreateRoleMutation,
    useUpdateRoleMutation,
    useDeleteRoleMutation,
    useGetMyRoleQuery,
    useGetPermissionsQuery,
} = roleApi;